<template>
    <b-tab :title="$t('INTERNALREPORT')" @click="getData()">
        <div class="">
            <div class="row">
          <div class="col-sm-12  table-responsive">
              <table class="table table-bordered table-striped table-hover table-sm table-logoped">
                <thead>
                  <tr>
                    <th>
                      {{$t('DATETIME')}}
                    </th>
                    <th>
                      {{$t('ACTION')}}
                    </th>
                  </tr>
                </thead>
                <tbody>
                    <tr v-for="item in response.root" :key="item.roomId" aria-rowindex="1" class=" table-ellipsis">
                      <td>{{moment(item.dateTime).format('DD.MM.YYYY HH:mm:ss')}}</td>
                      <td><button type="button" class="btn button-add"  @click="showResultAndOpinion(item)">{{$t('RESULTANDOPINION')}}</button></td>
                    </tr>
                </tbody>
              </table>
              <nav>
                <pagination v-bind:totalCount="response.totalCount" v-model="pagination" v-on:reload="getData">
                </pagination>
              </nav>
          </div>
        </div>
        </div>
    </b-tab>
    </template>
    
    <script>
    import Api from '@/api/child/Child';
    
    export default
    {
        name: 'ChildHistoryWin',
        props: ['childId'],
        data()
        {
            const me = this;
            return {
                response:
          {},
                pagination:
          {
              query: '',
              currentPage: 1,
              limit: 25,
              searchTimeout: false,
              initialId: null,
              sort: null,
              readingType: null,
          },
            };
        },
        created()
        {
            const me = this;
            me.getData();
        },
        methods:
      {
          async getData()
          {
              const me = this;
              try
              {
                  const data = await Api.selectHistoryRow(me.getParams);
                  if (data.error && data.error === true)
                  {
                      me.$notify.notice(data);
                      me.loading = false;
                      return;
                  }
    
                  me.response = data;
              }
              catch (e)
              {
                console.log(e);
                  me.$notify.notice(e);
              }
          },
          async showResultAndOpinion(item)
          {
              const me = this;
              try
              {
                  await Api.printPreviouseToPdf({ childId: me.$route.params.childId, childHistoryId: item.childHistoryId });
              }
              catch (e)
              {
                  me.$notify.notice(e);
              }
          },
      },
        watch:
      {
          pagination:
        {
            deep: true,
            handler()
            {
                const me = this;
    
                if (me.searchTimeout !== false)
                {
                    clearTimeout(me.searchTimeout);
                }
    
                me.searchTimeout = setTimeout(() =>
                {
                    me.getData();
                    me.searchTimeout = false;
                }, 300);
            },
        },
      },
        computed:
      {
          getParams()
          {
              const me = this;
              const data = {
                  ...me.pagination,
              };
              data.start = (data.currentPage - 1) * data.limit;
              data.childId = me.childId;
              return data;
          },
      },
    };
    </script>
    